import proj4 from 'proj4';
import { get as getProj, addProjection, addCoordinateTransforms } from 'ol/proj';
import { register } from 'ol/proj/proj4.js';

let initialized = false;

export const extent3006 = [
    181896.32913603852,
    6091282.433471196,
    1086312.9422175875,
    7900115.659634294
];

/**
 * Resolutions from the GWC "Sweref 99 TM" TileMatrixSet (ScaleDenominator * 0.00028).
 * All map views use these, so a stored zoom level shows the same scale in the admin preview and the public map.
 */
export const resolutions3006 = [
    3532.8773948498006, 1766.4386974249003, 883.2193487124501,
    441.60967435622507, 220.80483717811254, 110.40241858905627,
    55.201209294528134, 27.600604647264067, 13.800302323632033,
    6.900151161816017, 3.4500755809080084, 1.7250377904540042,
    0.8625188952270021, 0.43125944761350093, 0.21562972380675047,
    0.1078148619033753, 0.0539074309516876, 0.0269537154758438,
    0.0134768577379219, 0.006738428868961, 0.0033692144344805
];

export function initProjections(): void {
    if (initialized) return;

    proj4.defs("EPSG:3016", "+proj=tmerc +lat_0=0 +lon_0=20.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
    proj4.defs("EPSG:3006", "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ");
    proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs");
    register(proj4);

    const epsg3006 = getProj('EPSG:3006');
    const epsg3016 = getProj('EPSG:3016');
    const epsg4326 = getProj('EPSG:4326');
    addProjection(epsg3006);
    addProjection(epsg3016);
    addProjection(epsg4326);

    addCoordinateTransforms('EPSG:3857', epsg3006, proj4('EPSG:3857', 'EPSG:3006').forward, proj4('EPSG:3006', 'EPSG:3857').inverse);
    addCoordinateTransforms('EPSG:3857', epsg3016, proj4('EPSG:3857', 'EPSG:3016').forward, proj4('EPSG:3016', 'EPSG:3857').inverse);
    addCoordinateTransforms('EPSG:3857', epsg4326, proj4('EPSG:3857', 'EPSG:4326').forward, proj4('EPSG:4326', 'EPSG:3857').inverse);

    initialized = true;
}

export { proj4 };
